// import React from "react";
// import { Clock } from "lucide-react";

// const TimeMeasurements = ({ timeMeasurements }) => (
//   <div className="grid grid-cols-3 gap-8 mb-12">
//     {Object.entries(timeMeasurements).map(([key, value]) => (
//       <div
//         key={key}
//         className="text-center bg-gradient-to-b from-gray-900 to-gray-800 p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 ease-out"
//       >
//         <Clock
//           className="mx-auto mb-4 text-white animate-spin-slow"
//           size={64}
//           strokeWidth={1.5}
//         />
//         <p className="text-5xl font-extrabold text-white mt-2">{value}</p> {/* Larger font for better visibility */}
//         <p className="text-gray-400 capitalize mt-1">{key}</p> {/* Time type (e.g., hours, days) */}
//       </div>
//     ))}
//   </div>
// );

// export default TimeMeasurements;


import React from "react";
import { Clock } from "lucide-react";

const TimeMeasurements = ({ timeMeasurements }) => (
  <div className="grid grid-cols-3 gap-8 mb-12">
    {Object.entries(timeMeasurements).map(([key, value]) => (
      <div
        key={key}
        className="text-center bg-gradient-to-b from-gray-900 to-gray-800 p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 ease-out"
      >
        <Clock
          className="mx-auto mb-4 text-white animate-spin-slow"
          size={64}
          strokeWidth={1.5}
        />
        <p className="text-5xl font-extrabold text-white mt-2">{value}</p> {/* Larger font for better visibility */}
        <p className="text-gray-400 capitalize mt-1">{key}</p> {/* Time type (e.g., hours, days) */}
      </div>
    ))}
  </div>
);

export default TimeMeasurements;